module.exports = {
  "/": {
    "name": "root-redirect"
  },
  "/website": {
    "name": "storefront-home",
    "success": {
      "storefront home loaded": [
        "STOREFRONT_HOME_LOAD"
      ],
      "themes loaded": [
        "THEMES_LOAD"
      ]
    }
  },
  "/website/page/:pageNumber": {
    "name": "storefront-home-page",
    "success": {
      "themes loaded": [
        "THEMES_LOAD"
      ]
    }
  },
  "/website/categories": {
    "name": "all-categories",
    "success": {
      "all categories loaded": [
        "THEMES_ALL_BUSINESS_TYPES_LOAD"
      ]
    }
  },
  "/website/all": {
    "name": "all-storefront",
    "success": {
      "themes loaded": [
        "THEMES_LOAD"
      ]
    }
  },
  "/website/all/page/:pageNumber": {
    "name": "all-storefront-page",
    "success": {
      "themes loaded": [
        "THEMES_LOAD"
      ]
    }
  },
  "/website/themes/all-business-types": {
    "name": "themes-all-business-types-redirect"
  },
  "/website/themes/:slug": {
    "name": "theme-details-redirect"
  },
  "/website/:slugOrCategory": {
    "name": "theme-details-or-category",
    "success": {
      "theme details loaded": [
        "THEME_DETAILS_LOAD"
      ],
      "theme details preview forbidden error": [
        "THEME_DETAILS_FORBIDDEN_ERROR_LOAD"
      ],
      "theme details 404": [
        "THEME_DETAILS_403_LOAD"
      ],
      "theme details 403": [
        "THEME_DETAILS_404_LOAD"
      ],
      "themes loaded": [
        "THEMES_LOAD"
      ]
    },
    "error": [
      "THEME_DETAILS_ERROR_LOAD"
    ]
  },
  "/website/:category/page/:pageNumber": {
    "name": "storefront-category-page",
    "success": {
      "themes loaded": [
        "THEMES_LOAD"
      ]
    }
  },
  "/website/:category/:subcategory": {
    "name": "storefront-category-subcategory",
    "success": {
      "themes loaded": [
        "THEMES_LOAD"
      ]
    }
  },
  "/website/:category/:subcategory/page/:pageNumber": {
    "name": "storefront-category-subcategory-page",
    "success": {
      "themes loaded": [
        "THEMES_LOAD"
      ]
    }
  },
  "/modules": {
    "name": "modules-home",
    "success": {
      "modules loaded": [
        "MODULES_LOAD"
      ]
    }
  },
  "/modules/page/:pageNumber": {
    "name": "all-modules-storefront-page",
    "success": {
      "modules loaded": [
        "MODULES_LOAD"
      ]
    }
  },
  "/modules/:slugOrCategory": {
    "name": "module-details-or-category"
  },
  "/templates": {
    "name": "templates-home"
  }
};